export const state = {
    history: []
};
